import { action } from 'typesafe-actions';
import { ProgressActionTypes as act } from './actionTypes';
import { dispatchPageLoad } from '../../utils/analytics-helper';
import {
  isQCD,
  transactionType as getTransactionType,
} from 'src/utils/transactions-util';

export const setProgressFlag = (flag) => (dispatch) =>
  dispatch(action(`${act.SET_FLAG}_FULFILLED`, { flag }));

export const setProgress = (step: number, transactionType?) => {
  const trnxType = transactionType || getTransactionType();
  const payload = {
    transactionType: trnxType,
    currentStep: step,
  };
  if (step > 0) {
    if (isQCD() && step > 4) {
      dispatchPageLoad('Confirmation');
    } else {
      dispatchPageLoad(`Step ${step}`);
    }
  }

  return (dispatch) => {
    dispatch(action(`${act.SET_PROGRESS}_FULFILLED`, payload));
  };
};
